export default {
  setEndUseSortsLoading (state, status) {
    state.endUseSortsLoading = status
  },

  setEndUseSorts (state, endUseSorts) {
    state.endUseSorts = endUseSorts
  },

  addEndUseSorts (state, endUseSort) {
    state.endUseSorts.push(endUseSort)
  },

  removeEndUseSorts (state, endUseSortId) {
    state.endUseSorts = state.endUseSorts.filter(endUseSort => endUseSort.endUseSortId !== endUseSortId)
  },

  updateEndUseSorts (state, endUseSort) {
    const index = state.endUseSorts.findIndex(v => v.endUseSortId === endUseSort.endUseSortId)
    if (index !== -1) {
      Object.assign(state.endUseSorts[index], endUseSort)
    }
  }
}
